// extracted by mini-css-extract-plugin
export default {"Link":"UserBlockedEvent-module__Link__Co35MjL"};